import { render, staticRenderFns } from "./AssetsServices.vue?vue&type=template&id=cbef9930"
import script from "./AssetsServices.vue?vue&type=script&lang=js"
export * from "./AssetsServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports